const ActionPopupMenu = (props) => {
    return (
        <div className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px py-3" data-sai-menu="true" data-popper-placement="bottom-end">
            <div className="menu-item px-3" onClick={() => props.clickHandler('transfer')}>
                <a className="menu-link px-3">Transfer Chat</a>
            </div>
            <div className="menu-item px-3" onClick={() => props.clickHandler('session_end')}>
                <a className="menu-link px-3">End Session</a>
            </div>
        </div>
    )
}

export default ActionPopupMenu;